export default __webpack_public_path__ + "static/media/mascot.365675a9.png";